import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LeadForm } from "@/components/LeadForm";
import { SEO } from "@/components/SEO";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function ContactPage() {
    return (
        <div>
            <SEO title="Contact — bezoek onze showroom in Bornem"
                 description="Used Car Selection — Reedonk 4F, 2880 Bornem. Bel +32 479 44 27 98 of mail info@usedcarselection.be." />
            <Navbar />
            <section className="bg-[#0E2C4D] text-white">
                <div className="ucs-container py-16">
                    <div className="label-eyebrow text-[#EC6A0A] mb-3">Contact</div>
                    <h1 className="text-4xl md:text-5xl font-black tracking-tight">Neem contact op</h1>
                    <p className="mt-4 text-white/70 max-w-2xl">We staan klaar om je te helpen — telefonisch, per e-mail of in onze showroom.</p>
                </div>
            </section>

            <section className="ucs-container py-16 grid md:grid-cols-12 gap-12">
                <div className="md:col-span-5 space-y-6">
                    <ContactBlock icon={<MapPin />} title="Showroom" lines={["Reedonk 4F", "2880 Bornem (België)", "Bezoek enkel op afspraak"]} />
                    <ContactBlock icon={<Phone />} title="Bel ons" lines={["+32 479 44 27 98"]} />
                    <ContactBlock icon={<Mail />} title="Mail ons" lines={["info@usedcarselection.be"]} />
                    <ContactBlock icon={<Clock />} title="Openingstijden" lines={["Op afspraak"]} />
                    <div className="text-xs text-slate-500 pl-1">BTW BE 0787.385.523</div>
                </div>
                <div className="md:col-span-7">
                    <LeadForm title="Stuur ons een bericht" subtitle="We reageren doorgaans binnen één werkdag." />
                </div>
            </section>
            <Footer />
        </div>
    );
}

const ContactBlock = ({ icon, title, lines }) => (
    <div className="bg-white border border-slate-200 p-6 flex gap-4" style={{borderRadius: 2}}>
        <div className="w-12 h-12 bg-[#EC6A0A]/10 text-[#EC6A0A] flex items-center justify-center flex-shrink-0" style={{borderRadius: 2}}>
            {icon}
        </div>
        <div>
            <div className="label-eyebrow text-slate-500 mb-1">{title}</div>
            {lines.map((l, i) => <div key={i} className="text-[#0E2C4D] font-semibold">{l}</div>)}
        </div>
    </div>
);
